import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DnvFeatureLayer, DnvMapState, LayerType } from 'dnv-lib';
import { Layer, SelectedFeatureInspection } from 'src/app/state-management';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'dnv-cctv-inspections',
    templateUrl: './dnv-cctv-inspections.component.html',
    styleUrls: ['./dnv-cctv-inspections.component.scss'],
    standalone: false
})
export class DnvCctvInspectionsComponent implements OnInit {
  @Input() cctvInspections: SelectedFeatureInspection[];
  @Input() selectedCctvInspection: SelectedFeatureInspection;
  @Input() cctvNotes: any;
  @Input() inspHeight: number;
  @Input() excludeFeaturesList: any;
  @Input() featureLayers: any;
  @Input() layers: Layer[];
  @Input() surroundFeatureList: any;
  @Output() selectCctv = new EventEmitter<SelectedFeatureInspection>();
  @Output() highlightFeature = new EventEmitter<{ url: string, objectId: number }>();

  constructor() { }

  ngOnInit(): void {
    // GT-293 hide time 
    if (this.excludeFeaturesList && this.excludeFeaturesList.indexOf('Time') === -1) {
      this.excludeFeaturesList.push('Time');
    }
  }

  getInspectJobVals(attr: string[][]): { jobDate: string, assetId: string } {
    let assetId = '';
    let jobDate = '';
    for (const at of attr) {
      if (at[0].toLowerCase() === 'asset_id') {
        assetId = at[1];
      }
      if (at[0].toLowerCase() === 'date') {
        jobDate = at[1];
      }
    }
    return {
      jobDate, assetId
    };
    // return 'Inspected: ' + jobDate + '<br/>Asset: ' + assetId + '<br/>Job:' + jobNum;
  }

  selectInspection(inspection: SelectedFeatureInspection): void {
    if (inspection) {
      this.selectCctv.emit(inspection);
    }
  }

  backToInspections(): void {
    this.selectCctv.emit(null);
  }

  trackByFn(index: number, item: any): number {
    return index;
  }

  onCCTVHover(assetId: string) {
    // look up feature object id using asset id
    let objectId;
    if (this.surroundFeatureList) {
      objectId = this.surroundFeatureList.filter((s: any) => s.assetId === assetId)[0].objectId;
    }

    const featLayer = this.featureLayers.filter((f: { name: string | string[]; }) => f.name.indexOf('CCTVSanMain') > -1);
    if (featLayer) {
      const featureGisNum = featLayer[0].gisLayerNum;
      // see mousEnter() in dnv-feature-info.component.ts
      const layers = this.layers
        .filter((l: any) =>
          l.id === this.featureLayers[0].layer_Id
        );
      const matchingLayers: DnvFeatureLayer[] = layers
        .map((l: any) => l.featureLayers)
        .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []) // Poor man's FlatMap
        .filter((fl: any) => Number(fl.gisLayerNum) === Number(featureGisNum) && fl.name.indexOf('CCTV') > -1);

      if (1 === matchingLayers.length && objectId) {
        this.highlightFeature.emit({ url: matchingLayers[0].url, objectId });
      }
    }

  }

  mouseLeave() {
    this.highlightFeature.emit({ url: null, objectId: null });
  }

}
